import { influencerPageUrl, SELECTORS } from '$utils/constants';

import { checkIfNofiltersAreSelected, checkValidity } from './checkValidity';
import { displayElement } from './displayElement';
import { findProfiles } from './findProfiles';
import { formatNumber } from './formatNumber';
import { handleAgeSelect } from './handleAgeSelect';
import { setLocation } from './location';
import { populateProfiles } from './populateProfiles';
import { setUpDropDownListener } from './updateDropDownLabel';

const locationEl = document.querySelector(SELECTORS.location) as HTMLSelectElement;
const languageEl = document.querySelector(SELECTORS.language) as HTMLSelectElement;
const ageFromEl = document.querySelector(SELECTORS.ageFrom) as HTMLSelectElement;
const ageToEl = document.querySelector(SELECTORS.ageTo) as HTMLSelectElement;
const genderEl = document.querySelector(SELECTORS.gender) as HTMLSelectElement;

const locationAudienceEl = document.querySelector(SELECTORS.audienceLocation) as HTMLSelectElement;
const locationPercentageAudienceEl = document.querySelector(
  SELECTORS.audienceLocationPercentage
) as HTMLElement;
const languageAudienceEl = document.querySelector(SELECTORS.audienceLanguage) as HTMLSelectElement;
const languagePercentageAudienceEl = document.querySelector(
  SELECTORS.audienceLanguagePercentage
) as HTMLElement;
const ageFromAudienceEl = document.querySelector(SELECTORS.audienceAgeFrom) as HTMLSelectElement;
const ageToAudienceEl = document.querySelector(SELECTORS.audienceAgeTo) as HTMLSelectElement;
const genderAudienceEl = document.querySelector(SELECTORS.audienceGender) as HTMLSelectElement;
const genderPercentageAudienceEl = document.querySelector(
  SELECTORS.audienceGenderPercentage
) as HTMLElement;
const findForm = document.querySelector(SELECTORS.findForm) as HTMLAnchorElement;

export const setupFilterComponents = (isHome: boolean) => {
  //add eventListeners
  setUpDropDownListener();

  // Initiating age select logic
  setLocation();
  handleAgeSelect(SELECTORS.ageFrom, SELECTORS.ageTo);
  handleAgeSelect(SELECTORS.audienceAgeFrom, SELECTORS.audienceAgeTo);
  findForm.addEventListener('submit', async (e: Event) => {
    e.stopPropagation();
    e.preventDefault();
    //const isValid = checkValidity(); replace with please select one filter
    const isValid = checkIfNofiltersAreSelected();
    // return if not valid
    if (!isValid) return;
    setLocation();

    // constructing req body
    const body = generateRequestBodyFromSelectedFilters();

    if (isHome) {
      localStorage.setItem('reqBody', JSON.stringify(body));
      window.location.replace(influencerPageUrl);
    } else {
      const findSuccess = document.querySelector(SELECTORS.findSuccess) as HTMLElement;
      displayElement(findSuccess, true);
      const fetchedProfiles = await findProfiles(body);

      if (fetchedProfiles) {
        const creatorTotal = document.querySelector(SELECTORS.creatorTotal) as HTMLElement;
        creatorTotal.innerText = formatNumber(fetchedProfiles.metadata.total_results).toString();
        populateProfiles(fetchedProfiles.data);
        return;
      }
    }
  });
};

const generateRequestBodyFromSelectedFilters = () => {
  // getting workplatformid
  const work_platform_id = (document.querySelector(SELECTORS.platform) as HTMLSelectElement).value;

  const body: any = {
    work_platform_id: work_platform_id,
    sort_by: { field: 'TOTAL_VIEWS_GROWTH', order: 'DESCENDING' },
    limit: 7,
    offset: 0,
  };

  //check creator filters
  if (locationEl.value !== 'default') {
    body['creator_locations'] = [locationEl.value];
  }
  if (languageEl.value !== 'default') {
    body['creator_language'] = { code: languageEl.value };
  }
  if (ageFromEl.value !== 'default' && ageToEl.value !== 'default') {
    body['creator_age'] = {
      min: parseInt(ageFromEl.value),
      max: parseInt(ageToEl.value),
    };
  }
  if (genderEl.value !== 'default') {
    body['creator_gender'] = genderEl.value;
  }

  //check audience filters

  if (genderAudienceEl.value !== 'default') {
    body['audience_gender'] = {
      type: genderAudienceEl.value,
      operator: 'GT',
      percentage_value: parseInt(genderPercentageAudienceEl.innerText),
    };
  }

  if (ageFromAudienceEl.value !== 'default' && ageToAudienceEl.value !== 'default') {
    body['audience_age'] = {
      min: parseInt(ageFromAudienceEl.value),
      max: parseInt(ageToAudienceEl.value),
    };
  }

  if (languageAudienceEl.value !== 'default') {
    body['audience_language'] = [
      {
        code: languageAudienceEl.value,
        percentage_value: parseInt(languagePercentageAudienceEl.innerText),
      },
    ];
  }

  if (locationAudienceEl.value !== 'default') {
    body['audience_locations'] = [
      {
        location_id: locationAudienceEl.value,
        percentage_value: parseInt(locationPercentageAudienceEl.innerText),
        operator: 'GT',
      },
    ];
  }

  return body;
};
